<template>
	<div class="tixian-record">
		<nut-scroller
			:is-un-more="isUnMore"
			:is-loading="isLoading"
			:type="'vertical'"
			@loadMore="loadMoreVert"
			@pulldown="pulldown"
		>
			<div slot="list" class="nut-vert-list-panel">
				<template v-if="listData && listData.length">
					<div class="pintuan-item" v-for="(item, index) in listData" :key="index">
						<div class="flex record-item">
							<nut-avatar bg-icon :bg-image="userHeadPic" class="picture"></nut-avatar>
							<ul class="flex-g-1">
								<li class="title">零钱提现-到微信</li>
								<li class="datetime">{{item.CreateTime}}
									<p v-if="item.State == '0'">待审核</p>
									<p v-else-if="item.State == '2'">已拒绝</p>
								</li>
							</ul>
							<ul>
								<li class="count" v-if="item.State == '1'">-{{item.PayMoney}}元</li>
								<li class="count" v-else-if="item.State == '2'">+{{item.PayMoney}}元</li>
								<li class="restofcount">余额：{{parseFloat(userBalance).toFixed(2) || '0.00'}}</li>
							</ul>
						</div>
					</div>
				</template>
				<empty v-else></empty>
			</div>
		</nut-scroller>
	</div>
</template>

<script>
import empty from '../Empty'

export default {
	name: 'tixian_record',
	components: {empty},
	metaInfo: {
		title: '提现记录',
		titleTemplate: null,
	},

	data: () => ({
		listData: [],
		isUnMore: false,
		isLoading: false,
		page: 1,
		maxPages: 15,
		userHeadPic:'',
		userBalance:'0.00',
	}),
	created() {
		this.getList();
		this.$ajax.get('m/user/getlocal_user_info',{}).then(res => {
			this.userHeadPic = res.head_pic;
			if(res.wallet){
				this.userBalance = res.wallet.balance;
			}else {
				this.userBalance = '0.00';
			}
		})
	},
	methods: {
		getList() {
			this.$ajax.get('m/wallet/withdraw_log', {
				id: this.$ajax.get_activity_id(),
				pageSize: this.pageSize,
				pageIndex: this.page
			}).then(res => {
				this.isLoading = false;
				this.pageSize = 10;
				if (res && res.length) {
					this.listData = res;
					this.isUnMore = false;
					this.page++;
				} else {
					this.isUnMore = true;
				}
			})
		},
		// 上拉
		loadMoreVert() {
			this.isLoading = true;
			this.getList();
		},
		// 下拉
		pulldown() {
			this.isLoading = true
			this.pageSize = 15;
			this.page = 1;
			this.getList();
		},
	},
}
</script>

<style lang="less" scoped>
.tixian-record {
	height: 100vh;
	background-color: #f8f8f8;
}
.record-item {
	display: flex;
	align-items: center;
	padding: 14px;
	background-color: #fff;
	border-bottom: 1px solid #e2e2e2;
	.picture {
		width: 44px;
		height: 44px;
	}
	.title {
		font-size: 15px;
		color: #333333;
        font-weight: bold;
        margin-bottom: 5px;
    }
    .datetime {
        font-size: 11px;
        color: #999999;
    }
    .count {
        font-size: 15px;
        color: #EB273B;
        font-weight: bold;
        margin-bottom: 3px;
    }
    .restofcount {
        font-size: 11px;
        color: #333333;
    }
}
</style>
